import * as serverReq from "./adminsCrud";
import {adminsSlice} from "./adminsSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = adminsSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
  
  dispatch(actions.adminNotification({ notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.adminNotification({notification: null}));

/* Load Admins Action */
export const fetchAdmins = _ => dispatch => {
  serverReq.getAllAdmins()
            .then(({data}) =>  dispatch(actions.adminsFetched({ data })))
            .catch(errorHandler(dispatch));
};

/* Add new Admin Action */
export const addAdmin = adminData => dispatch => {
  serverReq.addAdmin(adminData)
            .then(({data}) => dispatch(actions.adminCreated({data})))
            .catch(errorHandler(dispatch));
};

/* Update existing admin Action */
export const updateAdmin = adminData => dispatch => {
  serverReq.updateAdmin(adminData)
            .then(({data}) => dispatch(actions.adminUpdated({data})))
            .catch(errorHandler(dispatch));
};

/* Delete existing admin Action */
export const deleteAdmin = id => dispatch => {
  serverReq.deleteAdmin(id)
            .then(({data: {id}}) => dispatch(actions.adminDeleted({ id })))
            .catch(errorHandler(dispatch));
};
